import { render, staticRenderFns } from "./menumanagement.vue?vue&type=template&id=9ced61d8&scoped=true&"
import script from "./menumanagement.vue?vue&type=script&lang=js&"
export * from "./menumanagement.vue?vue&type=script&lang=js&"
import style0 from "./menumanagement.vue?vue&type=style&index=0&id=9ced61d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ced61d8",
  null
  
)

export default component.exports